import { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import api from "../api/api";
 
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
 
const SignupForm = () => {
  const [signupSuccess, setSignupSuccess] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
 
  const initialValues = {
    full_name: "",
    company_name: "",
    phone_number: "",
    email: "",
    password: "",
    confirmPassword: "",
  };
 
  const validationSchema = Yup.object({
    full_name: Yup.string().required("Name is required"),
    company_name: Yup.string().required("Company name is required"),
    phone_number: Yup.string()
      .required("Phone number is required")
      .matches(/^[0-9]{10}$/, "Fill proper 10-digit phone number"),
    email: Yup.string()
      .email("Invalid email format")
      .matches(
        /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
        "Email must be filled with proper domain"
      )
      .required("Email is required"),
    password: Yup.string()
      .min(6, "Password must be at least 6 characters")
      .required("Password is required"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password")], "Passwords must match")
      .required("Confirm password is required"),
  });
 
  const onSubmit = async (values, { setSubmitting, setErrors, resetForm }) => {
    try {
      const payload = { ...values };
      console.log("payload", payload);
 
      delete payload.confirmPassword;
 
      await api.post("auth/signup", payload);
 
      setSignupSuccess(true);
      resetForm();
    } catch (error) {
      if (error.response?.data?.message) {
        setErrors({ email: error.response.data.message });
      } else {
        setErrors({ email: "Signup failed. Please try again." });
      }
    } finally {
      setSubmitting(false);
    }
  };
 
  return (
    <>
      {!signupSuccess ? (
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {({ isSubmitting }) => (
            <Form>
              <div className="mb-3">
                <h6 className="auth">
                  Let's get Started by filling out the form Below.
                </h6>
                <label className="form-label" htmlFor="full_name">
                  Full Name <span className="text-danger">*</span>
                </label>
                <Field
                  type="text"
                  name="full_name"
                  className="form-control"
                  placeholder="Enter your name"
                />
                <ErrorMessage
                  name="full_name"
                  component="div"
                  className="invalid-feedback d-block"
                />
              </div>
 
              <div className="mb-3">
                <label className="form-label" htmlFor="company_name">
                  Company Name <span className="text-danger">*</span>
                </label>
                <Field
                  type="text"
                  name="company_name"
                  className="form-control"
                  placeholder="Enter company name"
                />
                <ErrorMessage
                  name="company_name"
                  component="div"
                  className="invalid-feedback d-block"
                />
              </div>
              <div className="mb-3">
                <label className="form-label" htmlFor="phone_number">
                  Phone Number <span className="text-danger">*</span>
                </label>
                <Field
                  type="text"
                  name="phone_number"
                  className="form-control"
                  placeholder="Enter your phone number"
                  maxLength="10"
                  onInput={(e) => {
                    e.target.value = e.target.value
                      .replace(/\D/g, "")
                      .slice(0, 10);
                  }}
                />
                <ErrorMessage
                  name="phone_number"
                  component="div"
                  className="invalid-feedback d-block"
                />
              </div>
              <div className="mb-3">
                <label className="form-label" htmlFor="email">
                  Email <span className="text-danger">*</span>
                </label>
                <Field
                  type="email"
                  name="email"
                  className="form-control"
                  placeholder="Enter your email"
                />
                <ErrorMessage
                  name="email"
                  component="div"
                  className="invalid-feedback d-block"
                />
              </div>
              <div className="mb-3 position-relative">
                <label className="form-label" htmlFor="password">
                  Password <span className="text-danger">*</span>
                </label>
                <Field
                  type={showPassword ? "text" : "password"}
                  name="password"
                  className="form-control"
                  placeholder="Enter password"
                />
                <span
                  onClick={() => setShowPassword(!showPassword)}
                  className="inputicon"
                >
                  {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                </span>
                <ErrorMessage
                  name="password"
                  component="div"
                  className="invalid-feedback d-block"
                />
              </div>
 
              <div className="mb-3 position-relative">
                <label className="form-label" htmlFor="confirmPassword">
                  Confirm Password <span className="text-danger">*</span>
                </label>
                <Field
                  type={showConfirmPassword ? "text" : "password"}
                  name="confirmPassword"
                  className="form-control"
                  placeholder="Re-enter password"
                />
                <span
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  className="inputicon"
                >
                  {showConfirmPassword ? (
                    <VisibilityOffIcon />
                  ) : (
                    <VisibilityIcon />
                  )}
                </span>
                <ErrorMessage
                  name="confirmPassword"
                  component="div"
                  className="invalid-feedback d-block"
                />
              </div>
 
              <button
                type="submit"
                className="btn btn-primary w-100"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Signing up..." : "Sign Up"}
              </button>
            </Form>
          )}
        </Formik>
      ) : (
        <div className="text-center">
          <h5 className="text-success">Signup Successful!</h5>
          <p>You can now log in to your account.</p>
          <button
            className="btn btn-primary"
            onClick={() => setSignupSuccess(false)}
          >
            Go to Login
          </button>
        </div>
      )}
    </>
  );
};
export default SignupForm;
 